function $5e5d11e830c78975$export$2e2bcd8739ae039(a, b) {
    return a + b;
}
function $5e5d11e830c78975$export$25f84be31b76e92(a, b) {
    return a + b;
}
function $5e5d11e830c78975$export$1c891a3202c0ba6a(a, b) {
    return a - b;
} // function calc(a, b) {
 //     return a + b
 // }
 // function m(a, b) {
 //     return a - b
 // }
 // export default {calc, m}


console.log((0, $5e5d11e830c78975$export$2e2bcd8739ae039)(2, 3));
console.log((0, $5e5d11e830c78975$export$25f84be31b76e92)(3, 7));
console.log((0, $5e5d11e830c78975$export$1c891a3202c0ba6a)(966, 1)); // import copy from "./js/calculator"
 // console.log(copy);
 // console.log(copy.calc(12, 13));
 // console.log(copy.m(1000, 500));


//# sourceMappingURL=f4-hm-6.58387767.js.map
